/* tslint:disable */
/* eslint-disable */
/**
 * Presentation API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssistantPromptRequestDto
 */
export interface AssistantPromptRequestDto {
    /**
     * 
     * @type {string}
     * @memberof AssistantPromptRequestDto
     */
    prompt: string;
    /**
     * 
     * @type {number}
     * @memberof AssistantPromptRequestDto
     */
    temperature: number;
}

/**
 * Check if a given object implements the AssistantPromptRequestDto interface.
 */
export function instanceOfAssistantPromptRequestDto(value: object): value is AssistantPromptRequestDto {
    if (!('prompt' in value) || value['prompt'] === undefined) return false;
    if (!('temperature' in value) || value['temperature'] === undefined) return false;
    return true;
}

export function AssistantPromptRequestDtoFromJSON(json: any): AssistantPromptRequestDto {
    return AssistantPromptRequestDtoFromJSONTyped(json, false);
}

export function AssistantPromptRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssistantPromptRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'prompt': json['prompt'],
        'temperature': json['temperature'],
    };
}

export function AssistantPromptRequestDtoToJSON(json: any): AssistantPromptRequestDto {
    return AssistantPromptRequestDtoToJSONTyped(json, false);
}

export function AssistantPromptRequestDtoToJSONTyped(value?: AssistantPromptRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'prompt': value['prompt'],
        'temperature': value['temperature'],
    };
}

